import { render, staticRenderFns } from "./Assistenza.vue?vue&type=template&id=3fe26df4&scoped=true"
import script from "./Assistenza.vue?vue&type=script&lang=js"
export * from "./Assistenza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe26df4",
  null
  
)

export default component.exports